import { render, staticRenderFns } from "./ViewStandardisedJob.vue?vue&type=template&id=39de488e&scoped=true"
import script from "./ViewStandardisedJob.vue?vue&type=script&lang=ts"
export * from "./ViewStandardisedJob.vue?vue&type=script&lang=ts"
import style0 from "./ViewStandardisedJob.vue?vue&type=style&index=0&id=39de488e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de488e",
  null
  
)

export default component.exports